import styled, { createGlobalStyle } from 'styled-components';

import variables from '../../../styles/variables';

export const PageScrollStyles = createGlobalStyle`
  html.js-drawer-open {
  @media only screen and (max-width: 480px) {
    touch-action: none;
    -webkit-overflow-scrolling: none;
    overflow: hidden;
    overscroll-behavior: none;
  }
  }
`;

// Dark overlay under drawer
export const Overlay = styled.div`
  position: fixed;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: rgba(0, 0, 0, 0);
  transition:
    visibility 700ms,
    background-color 600ms linear;
  z-index: 10000;
  display: none;

  @media only screen and (max-width: 480px) {
    display: flex;
  }
`;

// Main drawer component
export const DrawerContainer = styled.div`
  height: 55%;
  width: 100%;
  min-width: 320px;
  position: fixed;
  bottom: 0;
  right: 0;
  overflow: auto;
  z-index: 10001;
  background-color: ${variables.defaultBackground};
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 10px 10px 0 0;
  display: none;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  transform: translateY(100%);
  transition: transform 700ms;

  &.on-drawer-enter-done {
    transform: translateY(0);

    ~ ${Overlay} {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  &.on-drawer-exit {
    ~ ${Overlay} {
      background-color: rgba(0, 0, 0, 0);
    }
  }

  @media only screen and (max-width: 480px) {
    display: flex;
    min-width: 100%;
  }
`;

export const DrawerContent = styled.div`
  display: block;
  width: 100%;
  margin: 0 auto;
`;
